import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "supply-chain-sankey",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description:
      "A supply chain read left to right: how many distinct entities each stage holds, or every flow in detail with a focus on one node.",
    domain: "ott-piracy",
    visual: "Sankey",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: {
    kind: "chart",
    skeletonMinHeight: "34rem",
    // The simple view (the default) is a short row of totals, not the detailed flow.
    byConfig: (config) => (config.viewMode === "detailed" ? {} : { skeletonMinHeight: "24rem" }),
  },
  settings,
  defaultLayoutClassName: "col-span-12",
};
